import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import {
   CourseAssignment,
   createCourseAssignment as createCourseAssignmentFromMonolith,
   UnsavedCourseAssignment,
} from '~/monolith-api';
import { CommonRequestOptions } from '~/monolith-api/makeRequest';

export type CreateCourseAssignmentOptions = UnsavedCourseAssignment;

export type CreateCourseAssignmentResult = CourseAssignment;

const createCourseAssignmentSchema = z.object({
   courseAssignment: z.object({
      wikiid: z.number(),
      assignee_userid: z.number().nullable(),
      assignee_teamid: z.number().nullable(),
      due_within: z.number().nullable(),
   }),
});

export async function createCourseAssignment(
   courseAssignment: UnsavedCourseAssignment,
   options: CommonRequestOptions = {}
): Promise<CreateCourseAssignmentResult> {
   return await createCourseAssignmentFromMonolith(courseAssignment, options);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { courseAssignment } = createCourseAssignmentSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await createCourseAssignment(courseAssignment, {
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const createCourseAssignmentFromClient = (
   courseAssignment: CreateCourseAssignmentOptions
): ReturnType<typeof createCourseAssignment> => {
   return bff()
      .post(`/courses/_shared/create-course-assignment-modal/createCourseAssignment`, {
         courseAssignment,
      })
      .then(response => response.data);
};

export type CreateCourseAssignmentErrorCode =
   | 'course_assignments.create.insufficent_privileges'
   | 'course_assignments.create.course_not_found'
   | 'course_assignments.create.course_disabled';
